var render = function() {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showSku || _vm.showPoints
    ? _c(
        "div",
        {
          class: [
            _vm.$style.container,
            ((_obj = {}),
            (_obj[_vm.$style["product-detail"]] = _vm.isProductDetail),
            (_obj[_vm.$style["new-line"]] = _vm.useNewLine),
            _obj)
          ]
        },
        [
          _vm.showSku
            ? _c("div", { class: _vm.$style.sku, attrs: { itemprop: "sku" } }, [
                _c("span", { class: _vm.$style["sku-translation"] }, [
                  _vm._v(_vm._s(_vm.translations.item) + " #")
                ]),
                _vm._v(" "),
                _c("span", { class: _vm.$style["sku-value"] }, [
                  _vm._v(_vm._s(_vm.sku))
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showPoints
            ? _c(
                "div",
                {
                  class: [
                    _vm.$style.points,
                    ((_obj$1 = {}),
                    (_obj$1[_vm.$style["hide-before"]] = !_vm.showSku),
                    _obj$1)
                  ]
                },
                [
                  _c("span", { class: _vm.$style["points-translation"] }, [
                    _vm._v(_vm._s(_vm.translations.psv) + ":")
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      class: _vm.$style["points-value"],
                      attrs: { "data-testid": "sv" }
                    },
                    [_vm._v(_vm._s(_vm.fixedPoints))]
                  )
                ]
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }